import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import { FormattedMessage, defineMessages } from 'react-intl'
import { useFormatMessage } from 'src/providers/intl'
import { selectTcaLeadTimeHours } from 'src/store/selectors/tca'
import {
  selectContactFirstName,
  selectContactPhotoUri
} from 'src/store/selectors/contact'
import { Button, Text } from 'src/Components'
import { SYSTEM_REQUEST } from 'src/constants/messages'
import Question from 'src/Components/shared/Questions/QuestionSingleContainer'
import TimeFrame from './TimeFrame'
import successGifSource from './mortgage-coach-success.gif'

import styles from './MortgageCoachRequest.module.scss'

const propTypes = {
  handleClose: PropTypes.func.isRequired
}

const MortgageCoachSuccess = ({ handleClose }) => {
  const intlFormat = useFormatMessage()

  const hours = useSelector(selectTcaLeadTimeHours)
  const firstName = useSelector(selectContactFirstName)
  const avatarUri = useSelector(selectContactPhotoUri)

  return (
    <div className={styles.modalBody}>
      <div className={styles.modalInfo}>
        <img
          className={styles.image}
          src={successGifSource}
          alt={intlFormat(messages.gifAlt)}
        />
        <Text
          className={styles.tcaHeader}
          size='xl'
          align='center'
          data-qa='TCAConfirmationMessage'
        >
          <FormattedMessage
            id='MortgageCoach.confirmTCA.headline'
            defaultMessage='Hang tight! Your Total Cost Analysis will be sent via email {timeFrame}.'
            values={{ timeFrame: <TimeFrame hours={hours} /> }}
          />
        </Text>
      </div>
      <div className={styles.fill} />
      <Question
        className={classnames(styles.dm, styles.ctaMinWidth)}
        questionTopic={intlFormat(SYSTEM_REQUEST.mcSuccessTopic)}
        placeholder={intlFormat(messages.placeholder, { firstName: firstName })}
        avatarUri={avatarUri}
      />
      <div className={styles.fill} />
      <Button
        className={classnames(
          styles.ctaMinWidth,
          styles.modalButton,
          styles.button
        )}
        onClick={handleClose}
        data-qa='completeTCARequest'
      >
        <FormattedMessage
          id='MortgageCoach.confirmTCA.button'
          defaultMessage='Sounds good'
        />
      </Button>
    </div>
  )
}

MortgageCoachSuccess.propTypes = propTypes

export default MortgageCoachSuccess

const messages = defineMessages({
  gifAlt: {
    id: 'MortgageCoach.confirmTCA.successAlt',
    defaultMessage: 'Total Cost Analysis Success'
  },
  placeholder: {
    id: 'MortgageCoach.confirmTCA.question.placeholder',
    defaultMessage: 'Send {firstName} a quick note…'
  }
})
